/** Dispatched on window after OTP / login stores a token so App can flip auth state without full reload. */
export const LOGIN_SUCCESS_EVENT = 'app:login-success';
